// getTempLevel.js

export function getTempLevel(value, speciesId) {
  if (speciesId === 1) {
    // Dog
    if (value <= 32.9) return "error";
    if (value >= 33 && value <= 37.4) return "warning";
    if (value >= 37.5 && value <= 39.2) return "success";
    if (value >= 39.3 && value <= 39.9) return "warning";
    if (value >= 40.0) return "error";
  } else if (speciesId === 2) {
    // Cat
    if (value <= 34.0) return "error";
    if (value >= 35 && value <= 38.0) return "warning";
    if (value >= 38.1 && value <= 39.2) return "success";
    if (value >= 39.3 && value <= 39.9) return "warning";
    if (value >= 40.0) return "error";
  }

  // Default fallback if speciesId or value is invalid
  return "";
}